import app from './app.js';

/**
 * Main entry point for the application.
 * This function is called when the DOM is ready.
 */
document.addEventListener('DOMContentLoaded', () => {
  app.init();
});